import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import NavigationBar from './components/Navbar';
import CustomSearch from './components/custom/main';
import CustomCollection from './components/custom/uploaded_images';
import BatchUpload from './components/custom/batch_upload';
import ThirdPartySearch from './components/third_party/main';
import ProductDetails from './components/custom/product_details';
import ManualReview from './components/custom/manual_review';
import 'bootstrap/dist/css/bootstrap.min.css';
import './style.css';

function App() {
  const [domains, setDomains] = useState([]);
  const [selectedDomain, setSelectedDomain] = useState(null);

  // Fetch domain list once, restore persisted selection
  useEffect(() => {
    fetch('/api/domains')
      .then(res => res.json())
      .then(data => {
        const list = data.domains || [];
        setDomains(list);
        const storedId = localStorage.getItem('selected_domain_id');
        let selected = list.find(d => String(d.id) === String(storedId));
        if (!selected && list.length > 0) {
          selected = list.find(d => d.domain_name.toLowerCase() === 'map') || list[0];
        }
        if (selected) {
          localStorage.setItem('selected_domain_id', selected.id);
          localStorage.setItem('selected_qdrant_collection', selected.qdrant_collection);
          setSelectedDomain(selected);
        }
      })
      .catch(err => console.error('Error loading domains:', err));
  }, []);

  const handleDomainChange = (domain) => {
    if (selectedDomain?.id === domain.id) return;
    localStorage.setItem('selected_domain_id', domain.id);
    localStorage.setItem('selected_qdrant_collection', domain.qdrant_collection);
    setSelectedDomain(domain);
  };

  return (
    <div className="App">
      <NavigationBar domains={domains} selectedDomain={selectedDomain} handleDomainChange={handleDomainChange} />
      <main className="py-5">
        <Routes>
          <Route path="/" element={<Navigate to="/search/gemini" replace />} />
          <Route path="/search/gemini" element={<CustomSearch model="gemini" />} />
          <Route path="/search/qwen" element={<CustomSearch model="qwen" />} />
          <Route path="/search/ximilar" element={<ThirdPartySearch />} />
          <Route path="/collection" element={<CustomCollection selectedDomain={selectedDomain} />} />
          <Route path="/batch-upload" element={<BatchUpload />} />
          <Route path="/review" element={<ManualReview selectedDomain={selectedDomain} />} />
          <Route path="/details/:imageName" element={<ProductDetails />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;
